import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { BellIcon, ExternalLinkIcon, MenuIcon, SearchIcon } from 'lucide-react';
import { AdminSection, AdminSidebar, ADMIN_NAV } from '../components/admin/AdminSidebar';
import { StatsCards } from '../components/admin/StatsCards';
import { ProductsTable } from '../components/admin/ProductsTable';
import { ProductFormModal } from '../components/admin/ProductFormModal';
import { OrdersSection } from '../components/admin/OrdersSection';
import { ClientsSection } from '../components/admin/ClientsSection';
import { CategoriesSection } from '../components/admin/CategoriesSection';
import { DiscountsSection } from '../components/admin/DiscountsSection';
import { SettingsSection } from '../components/admin/SettingsSection';
import { Product } from '../types';
import { useScreenInit } from '../useScreenInit.js';
export function Admin() {
  const screenInit = useScreenInit();
  const [section, setSection] = useState<AdminSection>(screenInit.section as AdminSection ?? 'dashboard');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(Boolean(screenInit.modalOpen));
  const [editing, setEditing] = useState<Product | null>(null);
  const openCreate = () => {
    setEditing(null);
    setModalOpen(true);
  };
  const openEdit = (product: Product) => {
    setEditing(product);
    setModalOpen(true);
  };
  const title = ADMIN_NAV.find(n => n.id === section)?.label ?? 'Dashboard';
  return <div className="min-h-screen w-full bg-ink-900" data-id="element-737" data-mp="2wxz11v0f14x5">
      <AdminSidebar active={section} onSelect={setSection} open={sidebarOpen} onClose={() => setSidebarOpen(false)} data-id="element-738" data-mp="2ww4jmqocruxt" />

      <div className="lg:pl-64" data-id="element-739" data-mp="2nykcx27q16ft">
        {/* TOPBAR */}
        <header className="sticky top-0 z-40 flex h-16 items-center gap-4 border-b border-white/8 bg-ink-900/90 px-5 backdrop-blur lg:h-20 lg:px-8" data-id="element-740" data-mp="2iyg5e1osjm1q">
          <button type="button" onClick={() => setSidebarOpen(true)} aria-label="Abrir menú" className="p-2 text-white/60 hover:text-white lg:hidden" data-id="element-741" data-mp="2e0o3ceufmjjt">
            <MenuIcon className="h-5 w-5" data-id="element-742" data-mp="29cevqi717jnz" />
          </button>

          <div className="min-w-0 flex-1" data-id="element-743" data-mp="1uecu4djk989d">
            <h1 className="truncate font-display text-2xl uppercase tracking-wide text-white lg:text-3xl" data-id="element-744" data-mp="1ufe40eoubopi">
              {title}
            </h1>
            <p className="hidden text-xs text-white/35 lg:block" data-id="element-745" data-mp="2n1p5rso6nvnw">
              Jueves 6 de agosto, 2026
            </p>
          </div>

          <div className="relative hidden md:block" data-id="element-746" data-mp="2s0sblfbzm5wx">
            <SearchIcon className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-white/30" data-id="element-747" data-mp="2dcp0xsn0261s" />
            <input type="search" placeholder="Buscar en el panel..." aria-label="Buscar en el panel" className="w-56 border border-white/10 bg-ink-800 py-2.5 pl-9 pr-3 text-sm text-white placeholder:text-white/30 focus:border-pink-500 focus:outline-none" data-id="element-748" data-mp="2iaqpgt372xkn" />
          </div>

          <button type="button" aria-label="Notificaciones" className="relative p-2 text-white/60 transition-colors hover:text-white" data-id="element-749" data-mp="zarclohngl5o">
            <BellIcon className="h-5 w-5" data-id="element-750" data-mp="19246eln0dlec" />
            <span className="absolute right-1.5 top-1.5 h-2 w-2 rounded-full bg-pink-500" data-id="element-751" data-mp="143sve7kz94uj" />
          </button>

          <Link to="/" className="hidden items-center gap-2 border border-white/15 px-4 py-2.5 text-[10px] font-bold uppercase tracking-[0.14em] text-white/70 transition-colors hover:border-pink-500 hover:text-white sm:flex" data-id="element-752" data-mp="gdgdq4zxjtqr">
            Ver tienda
            <ExternalLinkIcon className="h-3.5 w-3.5" data-id="element-753" data-mp="ld2uupivpu4u" />
          </Link>
        </header>

        {/* CONTENT */}
        <main className="space-y-6 px-5 py-6 lg:px-8 lg:py-8" data-id="element-754" data-mp="20ta999u45x7b">
          {(section === 'dashboard' || section === 'stock') && <StatsCards data-id="element-755" data-mp="1wr6k5ieiuu3k" />}

          {(section === 'dashboard' || section === 'productos' || section === 'stock') && <ProductsTable onCreate={openCreate} onEdit={openEdit} data-id="element-756" data-mp="2s4hixkaw7edj" />}

          {(section === 'dashboard' || section === 'pedidos') && <OrdersSection data-id="element-757" data-mp="312jpsghb518q" />}

          {section === 'clientes' && <ClientsSection data-id="element-758" data-mp="311ruz7vjb7ji" />}

          {section === 'categorias' && <CategoriesSection data-id="element-759" data-mp="362fr27ymeekl" />}

          {section === 'descuentos' && <DiscountsSection data-id="element-760" data-mp="3b18x5fbkv3aq" />}

          {section === 'configuracion' && <SettingsSection data-id="element-761" data-mp="3b0r1okwqot3v" />}
        </main>
      </div>

      {modalOpen && <ProductFormModal product={editing} onClose={() => setModalOpen(false)} data-id="element-762" data-mp="3f1svunbsueyz" />}
    </div>;
}